import {compressPhotoFile} from "@mytour/platform";
import {RAMONAGE_MAX_PHOTOS, ramonagePhotoInputSchema} from "@mytour/shared";
import {type PhotoProcessingState, ReportPhotosField} from "@mytour/ui/form";
import type {Control, FieldErrors, UseFormGetValues, UseFormTrigger} from "react-hook-form";
import {z} from "zod";

export const photosStepSchema = z.object({
  photos: z.array(ramonagePhotoInputSchema).max(RAMONAGE_MAX_PHOTOS),
});

export type PhotosStepForm = z.infer<typeof photosStepSchema>;
export type {PhotoProcessingState} from "@mytour/ui/form";

type Props = {
  control: Control<PhotosStepForm>;
  errors: FieldErrors<PhotosStepForm>;
  getValues: UseFormGetValues<PhotosStepForm>;
  trigger: UseFormTrigger<PhotosStepForm>;
  disabled: boolean;
  onStateChange: (state: PhotoProcessingState) => void;
};

export function AppliancePhotosStep({errors, ...props}: Props) {
  return (
    <ReportPhotosField
      {...props}
      name="photos"
      error={errors.photos}
      compressPhotoFile={compressPhotoFile}
      labels={{
        sectionLabel: "Photos de l'appareil",
        photoAlt: (index) => `Photo ${index} de l'appareil`,
        counter: (count, maximum) => `${count} sur ${maximum}`,
        limitMessage: `Limite de ${RAMONAGE_MAX_PHOTOS} photos atteinte pour cet appareil.`,
      }}
    />
  );
}
